module.exports = __webpack_public_path__ + "fcabce4915e30f7f4f7ea6766f91a24e.svg";